import type { ReactNode } from "react";

import Bioanalista from "@/pages/Bioanalista";
import Dashboard from "@/pages/Dashboard";
import Dns from "@/pages/Dns";
import Imaging from "@/pages/Imaging";
import ImagingDetail from "@/pages/ImagingDetail";
import InstallLink from "@/pages/InstallLink";
import Laboratory from "@/pages/Laboratory";
import Licenses from "@/pages/Licenses";
import Login from "@/pages/Login";
import PlatformConfig from "@/pages/PlatformConfig";
import ServerDetail from "@/pages/ServerDetail";
import ServerEdit from "@/pages/ServerEdit";
import Servers from "@/pages/Servers";
import ServersReport from "@/pages/ServersReport";
import Users from "@/pages/Users";
import VisorMetrics from "@/pages/dashboard/VisorMetrics";
import BusinessReports from "@/pages/reports/Business";

import { APP_ROUTES } from "@/app/routes";

/**
 * Qué componente renderiza cada ruta.
 *
 * Va separado de `routes.ts` para que la navegación pueda consultar permisos
 * sin arrastrar el árbol completo de páginas.
 */
export const ROUTE_ELEMENTS: Record<string, ReactNode> = {
  login: <Login />,
  "install-link": <InstallLink />,
  dashboard: <Dashboard />,
  "dashboard-visor": <VisorMetrics />,
  users: <Users />,
  licenses: <Licenses />,
  "reports-business": <BusinessReports />,
  imaging: <Imaging />,
  "imaging-detail": <ImagingDetail />,
  laboratory: <Laboratory />,
  bioanalysis: <Bioanalista />,
  dns: <Dns />,
  "settings-platform": <PlatformConfig />,
  servers: <Servers />,
  "servers-report": <ServersReport />,
  "server-detail": <ServerDetail />,
  "server-edit": <ServerEdit />,
};

/**
 * Toda ruta declarada debe tener elemento. Si alguien añade una a `routes.ts` y
 * olvida el componente, esto falla al arrancar en vez de renderizar una página
 * en blanco silenciosamente.
 */
const missing = APP_ROUTES.filter((route) => !ROUTE_ELEMENTS[route.id]);
if (missing.length > 0) {
  throw new Error(
    `Rutas sin componente asociado: ${missing.map((route) => route.id).join(", ")}`
  );
}
